import { configureCardAppearance } from './design-summary-view.js'
import { showBigMoment, bigMomentUnit, showLengthWithUnits } from 'ws-units'

export function showBendingCheckSummary(project, results) {
  const design = project.design;
  const checks = results["bending_checks"];
  const controlling_unity = checks["controlling_unity"];
  const controlling_case = checks["controlling_case"];
  const controlling_Mu = checks["controlling_Mu"];
  const controlling_Mn = checks["controlling_Mn"];
  const controlling_equation = checks["controlling_code_equation"];
  const controlling_location = checks["controlling_loc"];
  const controlling_Lb = checks["controlling_Lb"];
  const nice_eq_index = Number(controlling_case.split('EQ')[1]);
  const nice_case = design.loadCombination["prettyEquations"][nice_eq_index-1]["EQ"];
  const success = controlling_unity < 1.0;
  const designStatusStr = success ? '<i class="fa fa-check"></i>' : '<i class="fa fa-remove"></i>';
  configureCardAppearance('bending-design-panel', success);

  let rows = [];

  // Demand row
  // if controlling euqation does not contain "Slenderness Ratio Exceeded"
  if (!controlling_equation.includes("Slenderness Ratio Exceeded")) {

    let demandLabel = project.isASD ? "Ma (Demand)" : "Mu (Demand)";
    rows.push(makeRow(demandLabel, `${showBigMoment(controlling_Mu)} ${bigMomentUnit()}`));

    // Capacity row
    let capacityLabel = project.isEngineeredLumber
      ? (project.shape.flitch ? "Mn + Mn<sub>steel</sub> (Capacity)" : "Mn (Capacity)")
      : (project.isASD ? "Mn/&Omega; (Capacity)" : (project.isNoDesign ? "Mn (Capacity)" : "&Phi; Mn (Capacity)"));
    rows.push(makeRow(capacityLabel, `${showBigMoment(controlling_Mn)} ${bigMomentUnit()}`));

    // Extra steel row for flitch
    if (project.isEngineeredLumber && project.shape.flitch) {
      rows.push(makeRow("Mn<sub>steel</sub> (Capacity)", "0.6 &middot; Fy &middot; Zx"));
    }
  }

  // Controlling equation row
  let eqValue = project.isEngineeredLumber
    ? (project.shape.flitch ? "Mu &le; Mn + Mn<sub>steel</sub>" : "Mu &le; Mn")
    : (project.isFormTechShape || !project.isNoDesign ? controlling_equation : "Mn = Fy &bull; Zx");
  rows.push(makeRow("Controlling Equation", eqValue));

  // Location row
  rows.push(makeRow("Location", showLengthWithUnits(controlling_location)));

  // Load combination row
  rows.push(makeRow("Load Combination", nice_case));

  // Lb row
  if (project.isEngineeredLumber) {
    rows.push(makeRow("Lb", "Assumed Continuous"));
  } else if (design.bracingType === 'unbraced' && design.designType !== 'None') {
    rows.push(makeRow("Lb - Unbraced", `Much larger than ${showLengthWithUnits(project.beam.TotalLength())}`));
  } else if (design.bracingType !== 'continuous' && design.designType !== 'None') {
    rows.push(makeRow(project.isSteelTee ? "Lb (stem tension assumed)" : "Lb", showLengthWithUnits(controlling_Lb)));
  }

  let str = `
    <div class="card-header">
      <div class="fs-6">
        ${designStatusStr} Bending
        <span class="float-end">${controlling_unity >= 10.0 ? '' : controlling_unity.toFixed(2)}</span>
      </div>
    </div>
    <div class='bg-white rounded-2'>
      <table class='table table-borderless'>
        ${rows.join('')}
      </table>
    </div>
  `;

  document.getElementById('bending-design-panel').innerHTML = str;
}

function makeRow(label, value) {
  return `<tr><td>${label}</td><td><span style='float:right;'>${value}</span></td></tr>`;
}
